import * as actionTypes from "../constants/cartConstants";
import * as API from "../../api";

export const addToCart = (id, qty) => async (dispatch, getState) => {
  const { data } = await API.getProduct(id);

  dispatch({
    type: actionTypes.ADD_TO_CART,
    payload: {
      product: {
        _id: data._id,
        name: data.name,
        image: data.image,
        price: data.price,
        countInStock: data.countInStock,
        images: data.images,
        brand: data.brand,
        sku: data.sku,
        category: data.category,
        rating: data.rating,
        isFeatured: data.isFeatured,
        user: data.user,
        store: data.store,
      },
      quantity: parseInt(qty),
    },
  });

  localStorage.setItem("cart", JSON.stringify(getState().cart.cartItems));
};

export const removeFromCart = (item) => (dispatch, getState) => {
  dispatch({
    type: actionTypes.REMOVE_FROM_CART,
    payload: item,
  });

  localStorage.setItem("cart", JSON.stringify(getState().cart.cartItems));
};
